import _slicedToArray from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import * as React from "react";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
function traverseFiber(fiber, ascending, selector) {
  if (!fiber) return;
  if (selector(fiber) === true) return fiber;
  var child = ascending ? fiber.return : fiber.child;
  while (child) {
    var match = traverseFiber(child, ascending, selector);
    if (match) return match;
    child = ascending ? null : child.sibling;
  }
}
function wrapContext(context) {
  try {
    return Object.defineProperties(context, {
      _currentRenderer: {
        get: function get() {
          return null;
        },
        set: function set() {}
      },
      _currentRenderer2: {
        get: function get() {
          return null;
        },
        set: function set() {}
      }
    });
  } catch (_) {
    return context;
  }
}
var FiberContext = wrapContext(React.createContext(null));
var FiberProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(FiberProvider, _React$Component);
  function FiberProvider() {
    _classCallCheck(this, FiberProvider);
    return _possibleConstructorReturn(this, _getPrototypeOf(FiberProvider).apply(this, arguments));
  }
  _createClass(FiberProvider, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */React.createElement(FiberContext.Provider, {
        value: this._reactInternals
      }, this.props.children);
    }
  }]);
  return FiberProvider;
}(React.Component);
var _React$__SECRET_INTER = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
  ReactCurrentOwner = _React$__SECRET_INTER.ReactCurrentOwner,
  ReactCurrentDispatcher = _React$__SECRET_INTER.ReactCurrentDispatcher;
function useFiber() {
  var root = React.useContext(FiberContext);
  if (!root) throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
  var id = React.useId();
  var fiber = React.useMemo(function () {
    var _a;
    return (_a = ReactCurrentOwner.current) != null ? _a : traverseFiber(root, false, function (node) {
      var state = node.memoizedState;
      while (state) {
        if (state.memoizedState === id) return true;
        state = state.next;
      }
    });
  }, [root, id]);
  return fiber;
}
function useContainer() {
  var fiber = useFiber();
  var root = React.useMemo(function () {
    return traverseFiber(fiber, true, function (node) {
      var _a;
      return ((_a = node.stateNode) == null ? void 0 : _a.containerInfo) != null;
    });
  }, [fiber]);
  return root == null ? void 0 : root.stateNode.containerInfo;
}
function useNearestChild(type) {
  var fiber = useFiber();
  var childRef = React.useRef();
  React.useLayoutEffect(function () {
    var _a;
    childRef.current = (_a = traverseFiber(fiber, false, function (node) {
      return typeof node.type === "string" && (type === void 0 || node.type === type);
    })) == null ? void 0 : _a.stateNode;
  }, [fiber]);
  return childRef;
}
function useNearestParent(type) {
  var fiber = useFiber();
  var parentRef = React.useRef();
  React.useLayoutEffect(function () {
    var _a;
    parentRef.current = (_a = traverseFiber(fiber, true, function (node) {
      return typeof node.type === "string" && (type === void 0 || node.type === type);
    })) == null ? void 0 : _a.stateNode;
  }, [fiber]);
  return parentRef;
}
function useContextBridge() {
  var _a, _b;
  var fiber = useFiber();
  var _React$useState = React.useState(function () {
      return /* @__PURE__ */new Map();
    }),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    contexts = _React$useState2[0];
  contexts.clear();
  var node = fiber;
  while (node) {
    var context = (_a = node.type) == null ? void 0 : _a._context;
    if (context && context !== FiberContext && !contexts.has(context)) {
      contexts.set(context, (_b = ReactCurrentDispatcher.current) == null ? void 0 : _b.readContext(wrapContext(context)));
    }
    node = node.return;
  }
  return React.useMemo(function () {
    return Array.from(contexts.keys()).reduce(function (Prev, context) {
      return function (props) {
        return /* @__PURE__ */React.createElement(Prev, null, /* @__PURE__ */React.createElement(context.Provider, __spreadProps(__spreadValues({}, props), {
          value: contexts.get(context)
        })));
      };
    }, function (props) {
      return /* @__PURE__ */React.createElement(FiberProvider, __spreadValues({}, props));
    });
  }, [contexts]);
}
export { FiberProvider, traverseFiber, useContainer, useContextBridge, useFiber, useNearestChild, useNearestParent };